module.exports = __webpack_public_path__ + "static/media/meter.fcf71f3e.svg";